import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionKeepaliveService } from '../services/session-keepalive.service';

const TOKEN_KEY = 'identity.token';

function getToken(): string | null {
  try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; }
}

function isJwtExpired(token: string): boolean {
  try {
    const parts = token.split('.');
    const payload = parts[1] ?? '';
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const data = JSON.parse(atob(padded));
    const exp = Number(data?.exp); // segundos
    if (!exp) return false;
    return Date.now() >= exp * 1000;
  } catch {
    return true; // si no se puede decodificar, tratar como inválido/expirado
  }
}

export const authGuard: CanActivateFn = (_route, state) => {

  const _router = inject(Router);
  const sessionKeepalive = inject(SessionKeepaliveService);
  const token = getToken();

  if (!token) {
    try { sessionStorage.removeItem(TOKEN_KEY); } catch { }

    return _router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  if (isJwtExpired(token)) {
    return sessionKeepalive.handleExpiredSession();
  }

  return true;
};
